"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _GeoClosestLocation = require("../../../darkmatter/GeoClosestLocation");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var SortByDistanceButton = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SortByDistanceButton, _React$Component);

  var _super = _createSuper(SortByDistanceButton);

  function SortByDistanceButton() {
    (0, _classCallCheck2["default"])(this, SortByDistanceButton);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(SortByDistanceButton, [{
    key: "renderSortingCompleteStatus",
    value: function renderSortingCompleteStatus() {
      return /*#__PURE__*/_react["default"].createElement("p", {
        className: "locations-filter-geostate-unavailable"
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
        name: "location arrow"
      }), "Distance sorting complete");
    }
  }, {
    key: "renderUserLocationUnavailableStatus",
    value: function renderUserLocationUnavailableStatus() {
      return /*#__PURE__*/_react["default"].createElement("p", {
        className: "locations-filter-geostate-unavailable"
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
        name: "location arrow"
      }), "Location unavailable");
    }
  }, {
    key: "renderLocationIdleStatus",
    value: function renderLocationIdleStatus() {
      var _this$props = this.props,
          loading = _this$props.loading,
          onSort = _this$props.onSort;
      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        onClick: onSort,
        content: "Sort by distance",
        icon: "location arrow",
        basic: true,
        loading: loading
      });
    }
  }, {
    key: "render",
    value: function render() {
      var locationSortingStatus = this.props.locationSortingStatus;
      var SortButton = null;

      if (locationSortingStatus === _GeoClosestLocation.LOCATION_STATUS.LOCATION_UNAVAILABLE) {
        SortButton = this.renderUserLocationUnavailableStatus();
      } else if (locationSortingStatus === _GeoClosestLocation.LOCATION_STATUS.FINISHED) {
        SortButton = this.renderSortingCompleteStatus();
      } else {
        SortButton = this.renderLocationIdleStatus();
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "locations-filter-geostate-label"
      }, SortButton);
    }
  }]);
  return SortByDistanceButton;
}(_react["default"].Component);

exports["default"] = SortByDistanceButton;